<script lang="ts">import { cfgToThemeCdnPath, formatBaseCurrency } from "@infinitro/config";
import { t, Verbiage } from "@infinitro/content";
import { stateActiveRace, stateActiveRaceCountdown } from "../state";
let prizePoolText = $derived($stateActiveRace ? formatBaseCurrency($stateActiveRace.prizePool, true, 10, true) : "");
let countdownSegments = $derived($stateActiveRaceCountdown ? [
	String($stateActiveRaceCountdown.days).padStart(2, "0"),
	String($stateActiveRaceCountdown.hours).padStart(2, "0"),
	String($stateActiveRaceCountdown.minutes).padStart(2, "0"),
	String($stateActiveRaceCountdown.seconds).padStart(2, "0")
] : []);
</script>

<div class="weekly-races-banner">
	<img
		src={cfgToThemeCdnPath('/halloween/weekly-races.png')}
		alt={$t(Verbiage.races_banner_alt)}
		class="illustration"
	/>
	<div class="content">
		<div class="title">
			<span class="prize">{prizePoolText}</span>
			<span class="label">{$t(Verbiage.weekly_races).replace('\n', ' ')}</span>
		</div>
		<div class="countdown">
			{#each countdownSegments as segment, index (index)}
				{#if index > 0}
					<span class="colon">:</span>
				{/if}
				<span class="countdown-box">{segment}</span>
			{/each}
		</div>
	</div>
</div>

<style>
	.weekly-races-banner {
		position: relative;
		display: flex;
		height: 62px;
		align-items: center;
		overflow: hidden;
		padding-left: 0.75rem;
		padding-right: 0.75rem;
		/* Bleeds past the sidebar's own px-3.5 (aside) padding to go edge-to-edge. */
		width: calc(100% + 28px);
		margin-inline: -14px;
		background-color: var(--halloween-4);
		border-block: 1px solid var(--halloween-5);
		border-radius: 0;
}

	.illustration {
		pointer-events: none;
		position: absolute;
		right: 0px;
		bottom: 0px;
		height: 100%;
		-o-object-fit: contain;
		   object-fit: contain;
}

	.content {
		position: relative;
		z-index: 1;
		display: flex;
		flex-direction: column;
		gap: 0.375rem;
}

	.title {
		display: flex;
		align-items: baseline;
		gap: 0.25rem;
		font-size: 12px;
		font-weight: 700;
		text-transform: uppercase;
		--tw-text-opacity: 1;
		color: rgb(255 255 255 / var(--tw-text-opacity, 1));
		font-family: var(--font-main);
}

	.prize {
		color: var(--color-highlight-1);
	}

	.countdown {
		display: flex;
		align-items: center;
		gap: 0.25rem;
}

	.countdown-box {
		display: flex;
		height: 24px;
		width: 24px;
		align-items: center;
		justify-content: center;
		border-radius: 8px;
		font-size: 12px;
		font-weight: 700;
		--tw-text-opacity: 1;
		color: rgb(255 255 255 / var(--tw-text-opacity, 1));
		background: radial-gradient(circle, var(--halloween-4) 0%, var(--halloween-3) 100%);
}

	.colon {
		font-weight: 700;
		--tw-text-opacity: 1;
		color: rgb(255 255 255 / var(--tw-text-opacity, 1));
}
</style>
